import { LicenseInfoItem } from 'pages/UserInfo/components/License/types';

export const Endpoint = () => `/api/v3/license/licenseList/`;

export const QueryKeyBase = () => ['license', 'list'] as const;
export const QueryKey = () => [...QueryKeyBase()] as const;

export type Response = {
    licenseList: LicenseInfoItem[];
};
